import React from "react";
import PropTypes from 'prop-types';
import _ from "lodash";

function Separator(props) {
  return (
    <div
      style={{
        position: "absolute",
        height: "100%",
        transform: `rotate(${props.turns}turn)`
      }}
    >
      <div style={props.style} />
    </div>
  );
}

Separator.propTypes = {
  turns: PropTypes.number.isRequired,
  style: PropTypes.object
}

function RadialSeparators(props) {
  const turns = 1 / props.count;
  return _.range(props.count).map(index => (
    <Separator
      key={index}
      turns={index * turns}
      style={props.style}
    />
  ));
}

RadialSeparators.propTypes = {
  count: PropTypes.number.isRequired,
  style: PropTypes.object
};

export default RadialSeparators;

